#look-hint{bottom:16px;right:16px;padding:8px 12px;font-size:.68rem;pointer-events:none;
  letter-spacing:.12em;text-transform:uppercase;color:var(--dim)}
